import React from 'react';

const Navigation = ({ 
  activeTab, 
  onTabChange, 
  selectedCompany, 
  onCompanyChange, 
  timePeriod, 
  onTimePeriodChange
}) => {
  const tabs = [
    { id: 'home', name: 'Dashboard', icon: '🏠' },
    { id: 'analytics', name: 'Analytics', icon: '📊' },
    { id: 'reports', name: 'Reports', icon: '📋' },
    { id: 'settings', name: 'Settings', icon: '⚙️' }
  ];

  const companies = [
    { id: '', name: 'All Companies' },
    { id: 'jungle', name: 'Jungle Co' },
    { id: 'tps', name: 'TPS Nutrients' },
    { id: 'bloom', name: 'Bloom City' }
  ];

  const timePeriods = [
    { id: 'weekly', name: 'Weekly' },
    { id: 'monthly', name: 'Monthly' },
    { id: 'quarterly', name: 'Quarterly' },
    { id: 'yearly', name: 'Yearly' }
  ];

  return (
    <div className="relative z-10 mb-8">
      {/* Navigation component without summary stats */}
    </div>
  );
};

export default Navigation; 